/**
 * @generated SignedSource<<02e0523b05006dd7503529f87d665779>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarTeamEventEditScreenDeleteCalendarEventMutation$variables = {
  connections: ReadonlyArray<string>;
  eventId: string;
};
export type CalendarTeamEventEditScreenDeleteCalendarEventMutation$data = {
  readonly deleteCalendarEvent: {
    readonly id: string;
  };
};
export type CalendarTeamEventEditScreenDeleteCalendarEventMutation = {
  response: CalendarTeamEventEditScreenDeleteCalendarEventMutation$data;
  variables: CalendarTeamEventEditScreenDeleteCalendarEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTeamEventEditScreenDeleteCalendarEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "deleteCalendarEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CalendarTeamEventEditScreenDeleteCalendarEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "deleteCalendarEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ad7f76775efc9805385401bacce19b7",
    "id": null,
    "metadata": {},
    "name": "CalendarTeamEventEditScreenDeleteCalendarEventMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarTeamEventEditScreenDeleteCalendarEventMutation(\n  $eventId: ID!\n) {\n  deleteCalendarEvent(id: $eventId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ec33754a73e2ab0a98e65e2f5c78bbb";

export default node;
